export const getQueryParamValue = key => {
  return new URL(window.location.href).searchParams.get(key) || '';
};

export const getImageUrl = hit => {
  let url = hit.style_card_image_url;
  if (!url) url = `https://mms-images.out.customink.com/mms/images/catalog/colors/${hit.product_id}/views/alt/front_medium.jpg?digest=000000028&ixw=160`;
  return url;
};
